import { HTTP } from '@/services/axios';

export async function getWeathers({filterText,orderCol,orderSort,page,records}){
    let result = {};
    
    await HTTP.get('/app/customWeather/WeatherBasic/getWeatherList.php',{
        params:{
            filterText,
            orderCol,
            orderSort,
            page,
            records
        }
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function getWeather({weatherId}){
    let result = {};
  
    await HTTP({
        method: 'get',
        url: `/app/customWeather/WeatherBasic/getWeatherData.php?weatherId=${weatherId}`,
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}


export async function unlockWeather(weatherId){
    let result = {};

    var data = {'myRecordID':weatherId};
    
    await HTTP({
        method: 'patch',
        url: '/app/customWeather/WeatherBasic/controlWeatherUnlock.php',
        data: data
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function createWeather({data}){
    let result = {};

    await HTTP({
        method: 'post',
        url: '/app/customWeather/WeatherBasic/controlWeatherSave.php',
        data: data
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function saveWeather({data}){
    let result = {};

    await HTTP({
        method: 'put',
        url: '/app/customWeather/WeatherBasic/controlWeatherSave.php',
        data: data
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function deleteWeather({data}){
    let result = {};
   
    await HTTP({
        method: 'delete',
        url: '/app/customWeather/WeatherBasic/controlWeatherDelete.php',
        data: data
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}